export class Sort {

    constructor(public direction: String,
                public property: String,
                public ignoreCase: boolean,
                public nullHandling: String,
                public ascending: boolean) {
    }
}
